module.exports = __webpack_public_path__ + "img/ertiga-booster-green.0469b10c.svg";